import { render, staticRenderFns } from "./InfoPanelControls.vue?vue&type=template&id=63669abe&scoped=true"
import script from "./InfoPanelControls.vue?vue&type=script&lang=ts"
export * from "./InfoPanelControls.vue?vue&type=script&lang=ts"
import style0 from "./InfoPanelControls.vue?vue&type=style&index=0&id=63669abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63669abe",
  null
  
)

export default component.exports